import {Typography} from '@mui/material';
import muiStyled from '@mui/material/styles/styled';

const HistoryTitle = muiStyled(Typography)(() => ({
  fontSize: 16,
  fontWeight: 'bold'
}));

export default HistoryTitle;
